import FieldsPayStubCompanyInfoNew from './FieldsPayStubCompanyInfoNew'

export default FieldsPayStubCompanyInfoNew
